import styled, { css } from "styled-components";

interface IContainer {
  margin: string;
}

export const Container = styled.div<IContainer>`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}

  svg,
  img,
  i {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;
